import ActionBarItem from '@rio-cloud/rio-uikit/ActionBarItem';
import { FormattedMessage } from 'react-intl';
import { APP_VERSION } from '../../appRelease';

type ActionBarItemProps = React.ComponentProps<typeof ActionBarItem>;

const ServiceInfo = (props: ActionBarItemProps) => {
    const title = (
        <div>
            <span>
                <FormattedMessage id='intl-msg:starterTemplate.moduleName' />
            </span>
            <span className='text-color-gray margin-left-10'>{APP_VERSION}</span>
        </div>
    );

    return (
        <ActionBarItem
            id={props.id ?? 'serviceInfo'}
            className={`myItem ${props.className ?? ''}`}
            {...props}
        >
            <ActionBarItem.Icon>
                <span className='icon rioglyph rioglyph-info-sign' />
            </ActionBarItem.Icon>
            <ActionBarItem.Popover title={title} />
        </ActionBarItem>
    );
};

export default ServiceInfo;
